import { render, staticRenderFns } from "./virtual.vue?vue&type=template&id=04cd12be&scoped=true&"
import script from "./virtual.vue?vue&type=script&lang=js&"
export * from "./virtual.vue?vue&type=script&lang=js&"
import style0 from "./virtual.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./virtual.vue?vue&type=style&index=1&id=04cd12be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cd12be",
  null
  
)

export default component.exports